module.exports = __webpack_public_path__ + "static/media/garni-menu-tapa.210fbe6a.jpg";